import { Divider, Grid, TablePagination } from "@mui/material";
import { currencyRound } from "../../../util/DoubleUtil";
import PixTransacaoView from "../../PixTransacao/PixTransacaoView";
import TablePaginationActions from "../../../shared/components/Table/Actions";
import Button from "../../UI/Button";
import { dateTimeFormat } from "../../../util/DateUtil";
import CartaoCreditoTransacaoView from "../../CartaoCreditoTransacao/CartaoCreditoTransacaoView";

const CantinaCreditoSolicitacaoPage = ({
  cantinaCreditoSolicitacaoPage,
  handleChangePage,
  handleVerificarPagamento,
}) => {
  return (
    <Grid container spacing={3}>
      {cantinaCreditoSolicitacaoPage.content.map(
        (cantinaCreditoSolicitacao) => (
          <>
            <Grid>
              {" "}
              <span style={{ fontWeight: "bold" }}>Código: </span>
              {cantinaCreditoSolicitacao.codigo}
            </Grid>
            <Grid>
              {" "}
              <span style={{ fontWeight: "bold" }}>Aluno: </span>
              {cantinaCreditoSolicitacao.aluno.nome}
            </Grid>
            <Grid>
              {" "}
              <span style={{ fontWeight: "bold" }}>Usuário: </span>
              {cantinaCreditoSolicitacao.usuario.nome}
            </Grid>
            <Grid>
              <span style={{ fontWeight: "bold" }}>Criação: </span>
              {dateTimeFormat(cantinaCreditoSolicitacao.createdAt)}
            </Grid>
            <Grid>
              <span style={{ fontWeight: "bold" }}>Última Atualização: </span>
              {dateTimeFormat(cantinaCreditoSolicitacao.lastModified)}
            </Grid>
            <Grid>
              <span style={{ fontWeight: "bold" }}>Valor Crédito: </span>
              {currencyRound(cantinaCreditoSolicitacao.valorCredito)}
            </Grid>
            <Grid>
              <span style={{ fontWeight: "bold" }}>Valor Crédito: </span>
              {currencyRound(cantinaCreditoSolicitacao.valorCredito)}
            </Grid>
            <Grid>
              <span style={{ fontWeight: "bold" }}>Enviado Providence: </span>
              {cantinaCreditoSolicitacao?.enviadoProvidence ? "Sim" : "Não"}
            </Grid>
            {cantinaCreditoSolicitacao?.pixTransacao && (
              <Grid size={12}>
                <PixTransacaoView
                  pixTransacao={cantinaCreditoSolicitacao.pixTransacao}
                />
              </Grid>
            )}
            {cantinaCreditoSolicitacao?.cartaoCreditoTransacao && (
              <Grid size={12}>
                <CartaoCreditoTransacaoView
                  cartaoCreditoTransacao={
                    cantinaCreditoSolicitacao.cartaoCreditoTransacao
                  }
                />
              </Grid>
            )}
            <Grid size={12}>
              <Button
                onClick={() =>
                  handleVerificarPagamento(cantinaCreditoSolicitacao.codigo)
                }
              >
                Verificar Pagamento
              </Button>
            </Grid>
            <Grid size={12}>
              <Divider />
            </Grid>
          </>
        )
      )}
      <Grid size={12}>
        <TablePagination
          rowsPerPageOptions={[]}
          rowsPerPage={
            cantinaCreditoSolicitacaoPage.size
              ? cantinaCreditoSolicitacaoPage.size
              : 0
          }
          component="div"
          count={cantinaCreditoSolicitacaoPage.totalElements}
          page={cantinaCreditoSolicitacaoPage.number}
          onPageChange={handleChangePage}
          labelDisplayedRows={({ from, to, count }) =>
            from +
            "-" +
            to +
            " de " +
            (count !== -1 ? count + " registros" : +" mais de " + to)
          }
          ActionsComponent={TablePaginationActions}
        />
      </Grid>
    </Grid>
  );
};

export default CantinaCreditoSolicitacaoPage;
